import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { getLogoutUri } from '@/app/actions/server';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { usePathname } from '@/i18n/routing';

export function ErrorInfosDisconnect() {
  const pathname = usePathname();
  const tDialog = useTranslations('ERROR_DIALOG');
  const tMessage = useTranslations('ERROR_MESSAGE');

  const { user } = useAuthenticatedContext();

  const handleLogout = async () => {
    await getLogoutUri({ redirectPath: pathname });
  };

  return user?.id && (
    <div className="error-disconnect">
      <div className="error-disconnect__info">
        <span>{tMessage('USER_MAIL_INFO')}</span>
        <span className="vp-subtitle-m">{user?.mail}</span>
      </div>
      <VpButton
        variant="secondary"
        onClick={() => handleLogout()}
      >
        {tDialog('USE_ANOTHER_ACCOUNT')}
      </VpButton>
    </div>
  );
}
